import { ApiResponseInfo } from 'types';

export enum AUTH_ERR_MSG {
  USER_SESSION_ORGANISATION = 'USER_MUST_SELECT_SESSION_ORGANISATION',
  USER_ACCEPT_TERMS = 'USER_MUST_ACCEPT_TERMS'
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginObj {
  redirectTo?: string;
  values?: LoginCredentials;
  context: string;
}

export interface OTPCredentials {
  code: string;
  cognitoUserSession: object;
}
/**
 * Parameters for Registration and AWS Auth Signup payload
 */
export interface RegistrationDataTypes {
  username: string;
  password: string;
  confirmPassword?: string;
  firstname: string;
  lastname: string;
}

export interface ConfirmationDataTypes {
  username: string;
  confirmationCode: string;
  password?: string;
}

export interface UserAccount {
  username: string;
  attributes: {
    email: string;
  };
  signInUserSession: {
    idToken: {
      jwtToken: string;
    };
  };
}

export interface LoginSuccessPayload {
  user: UserAccount;
}

export interface LoginFailurePayload {
  error: ApiResponseInfo;
}

export interface AuthCurrentUserPayload {
  user: UserAccount;
}
